var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8,
    viewBox: "0 0 16 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.902 1.684c.13-.13.13-.366 0-.522L14.832.118c-.132-.157-.367-.157-.525 0L9.761 4.685c-.418.526-2.561 1.148-3.502 0L1.686.118c-.131-.131-.367-.131-.524 0L.118 1.161A.37.37 0 0 0 0 1.435c0 .105.043.205.118.274l5.748 5.742c.367.34.837.549 1.334.549h1.594c.497 0 .968-.21 1.333-.549l5.776-5.768z"
  })));
};
export default SvgAngleDown;